module.exports = __webpack_public_path__ + "f608e0a91d2b523e199d29d934a8f000.svg";